import Header from "../components/home/header";
import Footer from "../components/home/footer";
import { useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { useEffect, useState } from "react";

const Checkout = () => {   // 🔥 FIXED
  const navigate = useNavigate();
  const { cart } = useCart();

  // redirect if cart is empty
  useEffect(() => {
    if (cart.length === 0) {
      navigate("/cart");
    }
  }, [cart, navigate]);

  const userEmail = localStorage.getItem("email");

  // redirect if user is not logged in
  useEffect(() => {
    if (!userEmail) {
      navigate("/login");
    }
  }, [navigate, userEmail]);

  const [form, setForm] = useState({
    name: "",
    phone: "",
    address: "",
    city: "",
    country: "",
    pincode: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    };

    const subtotal = cart.reduce(
      (total, item) => total + item.price * item.quantity,
      0
    );

    const delivery = subtotal > 500 ? 0 : 50;
    const finalTotal = subtotal + delivery;
  const handlePlaceOrder = async () => {
    try {
      const orderData = {
        user: JSON.parse(localStorage.getItem("user")),
        cart,                  // ✅ MULTIPLE PRODUCTS
        address: form,
        amount: finalTotal,
      };

      const res = await fetch("https://ankit1.jaskart.com/api/orders/cart-create", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(orderData),
      });

      const data = await res.json();

      if (data.success) {
        // 🚀 Redirect user to PhonePe checkout page
        window.location.href = data.checkoutPageUrl;
      } else {
        alert("Payment initiation failed");
      }

    } catch (error) {
      console.error(error);
      alert("Something went wrong");
    }
  };


  return (
    <>
      <Header />

      <div className="container-fluid">
        <div className="checkout-page container mt-5">
          <h2 className="text-center" style={{fontWeight:'600'}}>Checkout</h2>

          <div className="checkout-wrapper">

            {/* LEFT FORM */}
            <div className="checkout-form">
              <h3>Delivery Information</h3>

              <input type="text" name="name" placeholder="Full Name" onChange={handleChange} />
              <input type="text" name="phone" placeholder="Phone Number" onChange={handleChange} />
              <input type="text" name="address" placeholder="Address" onChange={handleChange} />
              <input type="text" name="city" placeholder="City" onChange={handleChange} />
              <input type="text" name="country" placeholder="Country" onChange={handleChange} />
              <input type="text" name="pincode" placeholder="Pincode" onChange={handleChange} />

              <button
                className="place-order-btn"
                onClick={handlePlaceOrder}
                style={{ boxShadow: "5px 5px gray", borderRadius: "30px" }}
              >
                Pay ₹{finalTotal}
              </button>

            </div>

            {/* RIGHT SUMMARY */}
            <div className="checkout-summary">
              <h3>Your Order</h3>

              {cart.map((item) => (
                <div className="checkout-item" key={item.id}>
                  <p>{item.name} × {item.quantity}</p>
                  <p>₹{item.price * item.quantity}</p>
                </div>
              ))}

              <hr />

             <div className="text-end">
                 <p>Subtotal: ₹{subtotal}</p>
                <p>Delivery: {delivery === 0 ? "FREE" : `₹${delivery}`}</p>

                <h3>Total: ₹{finalTotal}</h3>
             </div>
            </div>

          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Checkout;   // 🔥 FIXED
